// 帰り道のアンケート（src/pages/review）と管理画面（src/pages/admin/reviews）で
// 選択肢の文言を必ず揃えるための置き場。片方だけ直して表記がずれるのを防ぐ。

export const SCALE4 = [
  { v: 4, label: 'すぐ分かった' },
  { v: 3, label: 'だいたい分かった' },
  { v: 2, label: 'あまり分からなかった' },
  { v: 1, label: '分からなかった' },
];

export const SCALE5 = [
  { v: 5, label: 'ぜひまた来たい' },
  { v: 4, label: 'また来てもよい' },
  { v: 3, label: 'どちらとも' },
  { v: 2, label: 'あまり思わない' },
  { v: 1, label: '思わない' },
];

export const INTEREST = [
  { v: 'yes', label: '興味がある' },
  { v: 'maybe', label: '少し気になる' },
  { v: 'no', label: 'いまはない' },
];

export function labelOf(options: { v: number | string; label: string }[], v: number | string | null): string {
  if (v == null) return '無回答';
  return options.find((o) => o.v === v)?.label ?? '無回答';
}
